import $ from 'jquery'

function requestContent(step) {
  if (step == "credentials") {
    $(".fieldset__user-type").addClass("hide");
    $(".fieldset__user-credentials").removeClass("hide");
  } else {
    $(".fieldset__user-type").removeClass("hide");
    $(".fieldset__user-credentials").addClass("hide");
  }
}

$(function(){
  $(document).ready(function() {
    var anchor = $("#anchor").data('anchor');
    requestContent(anchor);

    $('#new_oog_user').on("click", "input[type=radio]", function(e) {
      $(".fieldset__user-type").toggleClass("hide")
      $(".fieldset__user-credentials").toggleClass("hide")

      // Conditionally change e-mail field for teachers
      if(e.target.id === "oog_user_user_type_1")
        $("input[name='oog_user[email]']")[0].placeholder = "Enter school e-mail address"
      else
        $("input[name='oog_user[email]']")[0].placeholder = "Enter email"

      history.pushState("credentials", null, "#credentials");
    });
  });

  window.addEventListener('popstate', function(e) {
    requestContent(e.state);
  });
});
